import React from 'react';
import { getEntities } from '../reducers/entities';
import { connect } from "react-redux";
import TemplateBuilder from './TemplateBuilder'
import { selectInvoice } from '../reducers/invoices';
import moment from 'moment'
import {
    MDBCol,
    MDBRow,
    MDBInput,
    MDBModal,
    MDBNavLink,
    MDBModalFooter,
    MDBModalBody,
    MDBModalHeader,
    MDBDataTable,
    MDBListGroup, MDBListGroupItem,
    MDBContainer, MDBInputGroup,
    MDBBtn
} from 'mdbreact';

const ClientSelectorComponent = ({ entities, onChangeText, value, viewOnly }) => {

    const [showPicker, showPickerVisible] = React.useState(false);
    const [searchTerm, setSearchTerm] = React.useState('');

    // Get initials for avatar
    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    // Filter entities based on search
    const filteredEntities = entities ? entities.filter(p => {
        const fullName = p.name + (p.surname ? ' ' + p.surname : '');
        return fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
               (p.email && p.email.toLowerCase().includes(searchTerm.toLowerCase()));
    }) : [];

    let selectedEntity = entities && entities.find(i => i._id == value);

    // Styles
    const clientCardStyle = {
        display: 'flex',
        alignItems: 'center',
        padding: 16,
        background: '#f8f9fa',
        borderRadius: 8,
        border: '1px solid #e8e8e8'
    };

    const avatarStyle = {
        width: 48,
        height: 48,
        borderRadius: '50%',
        background: '#19a6b7',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        fontSize: 16,
        marginRight: 16,
        flexShrink: 0
    };

    const clientInfoStyle = {
        flex: 1
    };

    const clientNameStyle = {
        fontSize: 16,
        fontWeight: 600,
        color: '#1a3a4a',
        marginBottom: 4
    };

    const clientDetailStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 13,
        color: '#666',
        marginBottom: 2
    };

    const selectButtonStyle = {
        padding: '12px 24px',
        background: '#19a6b7',
        color: 'white',
        border: 'none',
        borderRadius: 8,
        fontWeight: 500,
        fontSize: 14,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: 8
    };

    const changeButtonStyle = {
        padding: '8px 16px',
        background: 'transparent',
        color: '#19a6b7',
        border: '1px solid #19a6b7',
        borderRadius: 6,
        fontWeight: 500,
        fontSize: 13,
        cursor: 'pointer',
        marginLeft: 12
    };

    const listItemStyle = {
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        borderBottom: '1px solid #eee',
        cursor: 'pointer',
        transition: 'background 0.2s ease'
    };

    return (
        <div>
            {/* View Mode - Show selected client */}
            {viewOnly && selectedEntity && (
                <div style={clientCardStyle}>
                    <div style={avatarStyle}>
                        {getInitials(selectedEntity.name)}
                    </div>
                    <div style={clientInfoStyle}>
                        <div style={clientNameStyle}>{selectedEntity.name}{selectedEntity.surname ? ' ' + selectedEntity.surname : ''}</div>
                        {(selectedEntity.email) && (
                            <div style={clientDetailStyle}>
                                <i className="fas fa-envelope" style={{ color: '#19a6b7', width: 14 }}></i>
                                {selectedEntity.email}
                            </div>
                        )}
                        {(selectedEntity.phone || selectedEntity.contactNumber) && (
                            <div style={clientDetailStyle}>
                                <i className="fas fa-phone" style={{ color: '#19a6b7', width: 14 }}></i>
                                {selectedEntity.phone || selectedEntity.contactNumber}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Edit Mode - Show selected client with change button */}
            {!viewOnly && selectedEntity && (
                <div style={clientCardStyle}>
                    <div style={avatarStyle}>
                        {getInitials(selectedEntity.name)}
                    </div>
                    <div style={clientInfoStyle}>
                        <div style={clientNameStyle}>{selectedEntity.name}{selectedEntity.surname ? ' ' + selectedEntity.surname : ''}</div>
                        {(selectedEntity.email) && (
                            <div style={clientDetailStyle}>
                                <i className="fas fa-envelope" style={{ color: '#19a6b7', width: 14 }}></i>
                                {selectedEntity.email}
                            </div>
                        )}
                        {(selectedEntity.phone || selectedEntity.contactNumber) && (
                            <div style={clientDetailStyle}>
                                <i className="fas fa-phone" style={{ color: '#19a6b7', width: 14 }}></i>
                                {selectedEntity.phone || selectedEntity.contactNumber}
                            </div>
                        )}
                    </div>
                    <button
                        type="button"
                        style={changeButtonStyle}
                        onClick={() => showPickerVisible(true)}
                    >
                        <i className="fas fa-exchange-alt" style={{ marginRight: 6 }}></i>
                        Change
                    </button>
                </div>
            )}

            {/* No client selected - Show select button */}
            {!selectedEntity && !viewOnly && (
                <div style={{
                    padding: 24,
                    background: '#f8f9fa',
                    borderRadius: 8,
                    border: '2px dashed #ddd',
                    textAlign: 'center'
                }}>
                    <div style={{ marginBottom: 12, color: '#888' }}>
                        <i className="fas fa-user-plus" style={{ fontSize: 32, marginBottom: 8, display: 'block' }}></i>
                        No client selected
                    </div>
                    <button
                        type="button"
                        style={selectButtonStyle}
                        onClick={() => showPickerVisible(true)}
                    >
                        <i className="fas fa-search"></i>
                        Select Client
                    </button>
                </div>
            )}

            {/* Client Picker Modal */}
            <MDBModal isOpen={showPicker} toggle={() => showPickerVisible(false)} size="lg">
                <MDBModalHeader toggle={() => showPickerVisible(false)}>
                    <i className="fas fa-users" style={{ marginRight: 10, color: '#19a6b7' }}></i>
                    Select Client
                </MDBModalHeader>
                <MDBModalBody style={{ padding: 0 }}>
                    {/* Search Box */}
                    <div style={{ padding: 16, borderBottom: '1px solid #eee' }}>
                        <div style={{ position: 'relative' }}>
                            <i className="fas fa-search" style={{
                                position: 'absolute',
                                left: 14,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#999'
                            }}></i>
                            <input
                                type="text"
                                placeholder="Search clients by name or email..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '12px 12px 12px 42px',
                                    border: '1px solid #ddd',
                                    borderRadius: 8,
                                    fontSize: 14,
                                    outline: 'none'
                                }}
                            />
                        </div>
                    </div>

                    {/* Client List */}
                    <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                        {filteredEntities.length === 0 ? (
                            <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>
                                <i className="fas fa-search" style={{ fontSize: 24, marginBottom: 8, display: 'block' }}></i>
                                No clients found
                            </div>
                        ) : (
                            filteredEntities.map(p => (
                                <div
                                    key={p._id}
                                    style={listItemStyle}
                                    onClick={() => {
                                        onChangeText('entityId', p._id);
                                        showPickerVisible(false);
                                        setSearchTerm('');
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                >
                                    <div style={{
                                        ...avatarStyle,
                                        width: 40,
                                        height: 40,
                                        fontSize: 14,
                                        marginRight: 12
                                    }}>
                                        {getInitials(p.name)}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontWeight: 500, color: '#1a3a4a' }}>
                                            {p.name}{p.surname ? ' ' + p.surname : ''}
                                        </div>
                                        {p.email && (
                                            <div style={{ fontSize: 12, color: '#888' }}>{p.email}</div>
                                        )}
                                    </div>
                                    <i className="fas fa-chevron-right" style={{ color: '#ccc' }}></i>
                                </div>
                            ))
                        )}
                    </div>
                </MDBModalBody>
            </MDBModal>
        </div>
    )
};

class ClientSelectorComponentScreen extends React.Component {

    state = {
    }

    componentDidMount() {
        this.props.dispatchGetEntities();
    }

    render() {
        return (
            <ClientSelectorComponent
                {...this.props} />
        );
    }
}

const mapStateToProps = state => ({
    entities: state.entities.entities,
})

const mapDispatchToProps = {
    dispatchGetEntities: () => getEntities(),
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientSelectorComponentScreen)
